const baseCredentials = require('../../../form/credentials/form')

module.exports = {
    ...baseCredentials,
    extends: [
        '/',
        'base',
        'bootstrap5',
        'form',
        'form',
    ]
}